import React from 'react';
import { FiCloudLightning } from "react-icons/fi";
import { motion } from "framer-motion";

const ShimmerBorderCard = ({ problem, solution }) => {
  return (
    <div className="group relative mx-auto w-full max-w-sm overflow-hidden rounded-lg bg-slate-800 p-0.5 transition-all duration-500 hover:scale-[1.01] hover:bg-slate-800/50">
      <div className="relative z-10 flex flex-col items-center justify-center overflow-hidden rounded-[7px] bg-slate-900 p-8 transition-colors duration-500 group-hover:bg-slate-800 h-full">
        <FiCloudLightning className="relative z-10 mb-6 mt-2 rounded-full border-2 border-indigo-500 bg-slate-900 p-4 text-5xl text-indigo-500" />

        <h4 className="relative z-10 mb-4 w-full text-2xl font-bold text-slate-50">
          {problem}
        </h4>
        <p className="relative z-10 text-slate-400">
          {solution}
        </p>
      </div>

      <motion.div
        initial={{ rotate: "0deg" }}
        animate={{ rotate: "360deg" }}
        style={{ scale: 1.75 }}
        transition={{
          repeat: Infinity,
          duration: 3.5,
          ease: "linear",
        }}
        className="absolute inset-0 z-0 bg-gradient-to-br from-indigo-200 via-indigo-200/0 to-indigo-200 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
      />
    </div>
  );
};

export const OurVow: React.FC = () => {
  const problemSolutions = [
    {
      problem: "Hard-to-Navigate Interfaces",
      solution: "Simplified, AI-assisted navigation that adapts to each user's needs."
    },
    {
      problem: "Limited Support for Disabilities",
      solution: "Full compliance with WCAG 2.1 standards and adaptive features for visual, auditory, and motor impairments."
    },
    {
      problem: "Lack of Transparency",
      solution: "Clear, jargon-free communication about features, pricing, and policies."
    },
    {
      problem: "Exclusion of Underserved Communities",
      solution: "Affordable plans designed to serve underbanked and minority populations."
    }
  ];

  return (
    <div className="bg-white px-4 py-12 space-y-8">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Vow</h2>
        <p className="text-gray-600">
          We're addressing the most common accessibility complaints to redefine what digital platforms should deliver:
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {problemSolutions.map((item, index) => (
          <ShimmerBorderCard key={index} problem={item.problem} solution={item.solution} />
        ))}
      </div>
    </div>
  );
};

